import React from 'react';
import './NowPlaying.css';
import type { MetadataStatus } from '../../hooks/useRadioPlayer';

interface NowPlayingProps {
  title?: string | null;
  artist?: string | null;
  isMSESupported?: boolean;
  metadataStatus?: MetadataStatus;
  isPlaying?: boolean;
  hasEverPlayed?: boolean;
}

// Получение сообщения-плейсхолдера в зависимости от статуса
const getPlaceholderMessage = (
  metadataStatus: MetadataStatus | undefined,
  isPlaying: boolean,
  hasEverPlayed: boolean
): string => {
  // Если еще не было воспроизведения - показываем призыв к действию
  if (!hasEverPlayed) {
    return 'Нажми на кнопку, получишь результат...';
  }
  
  // Если воспроизведение не идет - показываем призыв к действию
  if (!isPlaying) {
    return 'Нажми на кнопку, получишь результат';
  }
  
  // Если воспроизведение идет, но метаданных нет
  if (metadataStatus === 'loading') {
    return 'Загрузка информации о треке...';
  }
  
  // Во всех остальных случаях показываем название станции
  return 'Радио Афродита';
};

const NowPlaying: React.FC<NowPlayingProps> = React.memo(({ 
  title, 
  artist, 
  isMSESupported = true,
  metadataStatus = 'idle',
  isPlaying = false,
  hasEverPlayed = false,
}) => {
  const hasMetadata = (title || artist) && hasEverPlayed;

  return (
    <div className="now-playing">
      <div className="track-info">
        {hasMetadata ? (
          <>
            {title && (
              <div key={title} className="track-title track-metadata-fade">
                {title}
              </div>
            )}
            {artist && (
              <div key={artist} className="track-artist track-metadata-fade">
                {artist}
              </div>
            )}
          </>
        ) : (
          <div className="track-placeholder">
            <div className={`track-notice ${metadataStatus === 'loading' && hasEverPlayed ? 'loading' : ''}`}>
              {getPlaceholderMessage(metadataStatus, isPlaying, hasEverPlayed)}
            </div>
          </div>
        )}
      </div>
    </div>
  );
});

NowPlaying.displayName = 'NowPlaying';

export default NowPlaying;
